<!-- Footer Component -->
<script>
	import { Col, Row, Container } from 'sveltestrap';
</script>



<!--START FOOTER ALTER-->
<div class="footer-alt">
	<Container>
		<Row>
			<Col lg="12">
				<div class="float-start pull-none ">
					<p class="copy-rights text-muted mb-3 mb-sm-0">
						{new Date().getFullYear()}
						© Plataforma Conecta - CGCAFE
					</p>
				</div>
				<div class="float-end pull-none ">
					<ul class="list-inline social m-0">
						<li class="list-inline-item">
							<a href={"https://es-es.facebook.com/cgcafeaaff.consejogeneral"} class="social-icon"><i class="mdi mdi-facebook" /></a>
						</li>
						<li class="list-inline-item">
							<a href={"https://twitter.com/cgcafeaaff"} class="social-icon"><i class="mdi mdi-twitter" /></a>
						</li>
						<li class="list-inline-item">
							<a href={"https://www.youtube.com/channel/UCQW3QrbQC3U3nhT7yXHh7kw/videos"} class="social-icon"><i class="mdi mdi-youtube" /></a>
						</li>
						<li class="list-inline-item">
							<a href={"https://afcolegiadosblog.com/"} class="social-icon"><i class="mdi mdi-wordpress" /></a>
						</li>
					</ul>
				</div>
				<div class="clearfix" />
			</Col>
		</Row>
	</Container>
</div>
<!--START FOOTER ALTER-->
